export default "__VITE_ASSET__5b2d59e7__"